import {gql} from "apollo-angular";

export const GET_AUDIT_LOGS = gql`
  query GetAuditLogs($filtering: AuditLogsInputObject) {
    getAuditLogs(filtering: $filtering) {
      response {
        id
        status
        code
        message
      }
      data {
        fullName
        username
        action
        actionTime
      }
    }
  }`
